<template>
  <div>
    <div>
      <cbs-widget-scalar
        v-if="item.widget.param.widgettype.sid === 'scalar'"
        :widget="item.widget"
      />
      <cbs-widget-scalar-vertical
        v-else-if="item.widget.param.widgettype.sid === 'scalarvertical'"
        :widget="item.widget"
      />
      <cbs-widget-chart
        v-else-if="item.widget.param.widgettype.sid === 'chart'"
        :widget="item.widget"
      />
      <cbs-widget-donut
        v-else-if="item.widget.param.widgettype.sid === 'donut'"
        :widget="item.widget"
      />
      <cbs-widget-object-link
        v-else-if="item.widget.param.widgettype.sid === 'objectlink'"
        :widget="item.widget"
      />
      <cbs-widget-quickadd
        v-else-if="item.widget.param.widgettype.sid === 'quickadd'"
        :widget="item.widget"
      />
      <cbs-widget-habit-day
        v-else-if="item.widget.param.widgettype.sid === 'habitday'"
        :widget="item.widget"
      />
      <cbs-widget-habit-coach
        v-else-if="item.widget.param.widgettype.sid === 'habitcoach'"
        :widget="item.widget"
      />
      <cbs-widget-habit-training
        v-else-if="item.widget.param.widgettype.sid === 'habittraining'"
        :widget="item.widget"
      />
      <cbs-widget-habit-health
        v-else-if="item.widget.param.widgettype.sid === 'habithealth'"
        :widget="item.widget"
      />
      <cbs-widget-habit-week
        v-else-if="item.widget.param.widgettype.sid === 'habitweek'"
        :widget="item.widget"
      />
      <cbs-widget-habit-month
        v-else-if="item.widget.param.widgettype.sid === 'habitmonth'"
        :widget="item.widget"
      />
      <cbs-widget-habit-chart
        v-else-if="item.widget.param.widgettype.sid === 'habitchart'"
        :widget="item.widget"
      />
      <cbs-widget-habit-stats
        v-else-if="item.widget.param.widgettype.sid === 'habitstats'"
        :widget="item.widget"
      />
      <cbs-widget-html
        v-else-if="item.widget.param.widgettype.sid === 'html'"
        :widget="item.widget"
      />
      <cbs-widget-blank
        v-else
        :widget="item.widget"
      />
    </div>
    <cbs-debug
      v-if="false"
      :context="this"
    />
  </div>
</template>

<script>
import CbsWidgetScalar from '@/cubus/components/dashboard/CbsWidgetScalar.vue'
import CbsWidgetScalarVertical from '@/cubus/components/dashboard/CbsWidgetScalarVertical.vue'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import CbsWidgetBlank from '@/cubus/components/dashboard/CbsWidgetBlank.vue'
import CbsWidgetChart from '@/cubus/components/dashboard/CbsWidgetChart.vue'
import CbsWidgetDonut from '@/cubus/components/dashboard/CbsWidgetDonut.vue'
import CbsWidgetObjectLink from '@/cubus/components/dashboard/CbsWidgetObjectLink.vue'
import CbsWidgetQuickadd from '@/cubus/components/dashboard/CbsWidgetQuickadd.vue'
import CbsWidgetHabitDay from '@/cubus/components/dashboard/CbsWidgetHabitDay.vue'
import CbsWidgetHabitCoach from '@/cubus/components/dashboard/CbsWidgetHabitCoach.vue'
import CbsWidgetHabitTraining from '@/cubus/components/dashboard/CbsWidgetHabitTraining.vue'
import CbsWidgetHabitHealth from '@/cubus/components/dashboard/CbsWidgetHabitHealth.vue'
import CbsWidgetHabitWeek from '@/cubus/components/dashboard/CbsWidgetHabitWeek.vue'
import CbsWidgetHabitMonth from '@/cubus/components/dashboard/CbsWidgetHabitMonth.vue'
import CbsWidgetHabitChart from '@/cubus/components/dashboard/CbsWidgetHabitChart.vue'
import CbsWidgetHabitStats from '@/cubus/components/dashboard/CbsWidgetHabitStats.vue'
import CbsWidgetHtml from '@/cubus/components/dashboard/CbsWidgetHtml.vue'

export default {
  name: 'CbsDashboardItem',
  components: {
    CbsDebug,
    CbsWidgetScalarVertical,
    CbsWidgetScalar,
    CbsWidgetBlank,
    CbsWidgetChart,
    CbsWidgetDonut,
    CbsWidgetObjectLink,
    CbsWidgetQuickadd,
    CbsWidgetHabitDay,
    CbsWidgetHabitCoach,
    CbsWidgetHabitTraining,
    CbsWidgetHabitHealth,
    CbsWidgetHabitWeek,
    CbsWidgetHabitMonth,
    CbsWidgetHabitChart,
    CbsWidgetHabitStats,
    CbsWidgetHtml,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>

</style>
